
@if (roleType && initialConfigurationComplete && !isLoading) {
  <section
    class="user-form-container d-flex flex-column"
    [class]="containerClass"
    [formGroup]="form"
    [class.edit-form-style]="isInEditMode">
    <!-- Password Requirement Tooltip List -->
    <ng-template #passwordToolTipContent>
      <zbp-password-requirements-tooltip></zbp-password-requirements-tooltip>
    </ng-template>
    @if (alertBarText) {
      <zbp-alert-bar-container [zbpIconName]="zbpIconNames.exclamation_in_circle" class="managed-by-institution-banner">
        <p class="alert-bar-text">{{alertBarText}}</p>
      </zbp-alert-bar-container>
    }
    @if (showRequiredLabelForAddMode) {
      <div class="text-uppercase requiredText">* Required</div>
    }
    @if (newUsers?.controls) {
      <div formArrayName="newUsers" id="createSchoolUsersRows" class="w-100" [class.edit-form]="isInEditMode">
        @for (uf of newUsers.controls; track uf; let i = $index) {
          <div [formGroupName]="i" class="newUserRow">
            <div  class="form-fields-container">
              <div class="newUserRowFormFields">
                @if (isInEditMode) {
                  <h5 class="form-section-title">User Information</h5>
                }
                <!-- First Name -->
                <div class="form-group form-input"
                  [class.parent-row-input]="isManagingParent">
                  <label class="form-label" for="newUser{{i}}FirstName"
                    [class.error]="formControlInvalidAndTouched(i, formFieldNames.firstName.name)">
                    {{formFieldNames.firstName.label}}
                    <span aria-hidden="true">*</span>
                  </label>
                  <input #firstName
                    id="newUser{{i}}FirstName"
                    type="text"
                    class="form-control"
                    required
                    aria-required="true"
                    [formControlName]="formFieldNames.firstName.name"
                    [class.is-invalid]="formControlInvalidAndTouched(i, formFieldNames.firstName.name)"
                    [attr.aria-invalid]="invalidFirstName"
                    [attr.aria-describedby]="invalidFirstName ? 'firstNameError' : ''"
                    [ngbTooltip]="(usesOneRoster && !userCanBeEditedIfOneRoster) ? oneRosterTooltipText : ''">
                  <div
                    class="errorWrapper">
                    @if (formControlInvalidAndTouched(i, formFieldNames.firstName.name)) {
                      <span
                        class="errorText error"
                      id="firstNameError">{{nameFieldErrorText(i, formFieldNames.firstName.name)}}</span>
                    }
                  </div>
                </div>
                <!-- Last Name -->
                <div class="form-group form-input" [class.parent-row-input]="isManagingParent">
                  <label class="form-label" for="newUser{{i}}LastName" [class.error]="formControlInvalidAndTouched(i, formFieldNames.lastName.name)">
                    {{formFieldNames.lastName.label}}
                    <span aria-hidden="true">*</span>
                  </label>
                  <input id="newUser{{i}}LastName" type="text"
                    class="form-control"
                    required
                    aria-required="true"
                    [formControlName]="formFieldNames.lastName.name"
                    [class.is-invalid]="formControlInvalidAndTouched(i, formFieldNames.lastName.name)"
                    [attr.aria-invalid]="invalidLastName"
                    [attr.aria-describedby]="invalidLastName ? 'lastNameError' : ''"
                    [ngbTooltip]="(usesOneRoster && !userCanBeEditedIfOneRoster) ? oneRosterTooltipText : ''">
                  <div
                    class="errorWrapper"
                    >
                    @if (formControlInvalidAndTouched(i, formFieldNames.lastName.name)) {
                      <span
                        class="errorText error"
                      id="lastNameError">{{nameFieldErrorText(i, formFieldNames.lastName.name)}}</span>
                    }
                  </div>
                </div>
                <!-- Non-student Username Fields -->
                @if (!isManagingStudent) {
                  <div class="form-group form-input" [class.lastInputGroup]="!uf.get(formFieldNames.password.name)" [class.full-width]="isInEditMode && (isManagingSchoolAdmin || isManagingDistrictAdmin || isManagingTeacher || isManagingParent)"  [class.parent-row-input]="isManagingParent">
                    <label class="form-label" for="newUser{{i}}UserName" [class.error]="formControlInvalidAndTouched(i, formFieldNames.username.name)">
                      {{formFieldNames.username.label}}
                      <span aria-hidden="true">*</span>
                    </label>
                    <button id="emailTooltipButton"
                      tabindex="0"
                      type="button"
                      class="btn btn-xs"
                      aria-label="tooltip"
                      [ngbTooltip]="'Provide the Email with which the user will log in.'"
                      triggers="mouseenter:mouseleave focus:blur click"
                      placement="top-left">
                      <i class="fa-regular fa-circle-question"
                      aria-hidden="true" ></i>
                    </button>
                    <input id="newUser{{i}}UserName"
                      type="email"
                      class="form-control"
                      required aria-required="true"
                      [formControlName]="formFieldNames.username.name"
                      [class.is-invalid]="formControlInvalidAndTouched(i, formFieldNames.username.name)"
                      [attr.aria-invalid]="invalidUsername"
                      [attr.aria-describedby]="invalidUsername && !isManagingStudent ? 'usernameError' : ''"
                      [ngbTooltip]="(usesOneRoster && !userCanBeEditedIfOneRoster) ? oneRosterTooltipText : ''">
                    <div
                      class="errorWrapper">
                      @if (formControlInvalidAndTouched(i, formFieldNames.username.name)) {
                        <span
                          class="errorText error"
                        id="usernameError">{{nameFieldErrorText(i, formFieldNames.username.name)}}</span>
                      }
                    </div>
                  </div>
                }
                <!-- External ID -->
                @if (isManagingStudent) {
                  <div class="form-group form-input" id="externalIdContainer">
                    <label class="form-label" for="newUser{{i}}ExternalId">
                      External ID
                    </label>
                    <button tabindex="0"
                      id="newUser{{i}}ExternalIdTooltipButton"
                      type="button"
                      class="btn question-button-icon"
                      aria-label="tooltip"
                      [ngbTooltip]="'Optionally provide the system identifier for this student from your Student Information System or Learning Management System.'"
                      triggers="mouseenter:mouseleave focus:blur click"
                      [placement]="['auto']">
                      <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
                    </button>
                    <input
                      id="newUser{{i}}ExternalId"
                      type="text"
                      class="form-control no-error-placeholder"
                      [ngbTooltip]="(usesOneRoster && !userCanBeEditedIfOneRoster) ? oneRosterTooltipText : ''"
                      formControlName="externalId">
                  </div>
                }
                <!-- Student Search for Parents in Edit Mode -->
                @if (isManagingParent && !isInEditMode) {
                  <div class="form-group form-input lastInputGroup parent">
                    <!-- zbp-user-search-with-dropdown adds correct ID to input to match label -->
                    <label for="studentUsername{{ i }}" class="form-label" [class.error]="studentFormControlInvalid(getStudentFormControl(i))">
                      Search Existing Students
                      <span aria-hidden="true">*</span>
                    </label>
                    <zbp-user-search-with-dropdown
                      [i]="i"
                      [school]="school"
                      [role]="RoleType.Student"
                      [control]="getStudentFormControl(i)"
                      [isInvalid]="studentFormControlInvalid"
                      [includeSearchExistingLabel]="false"
                      [ariaDescribedBy]="'searchStudentError'"
                      >
                    </zbp-user-search-with-dropdown>
                    <div class="errorWrapper">
                      @if (studentFormControlInvalid(getStudentFormControl(i))) {
                        <span
                          class="errorText error"
                        id="searchStudentError">{{nameFieldErrorText(i, formFieldNames.student.name)}}</span>
                      }
                    </div>
                  </div>
                }
                <!-- Student Username Field -->
                @if (isManagingStudent) {
                  <div id="studentUsernameContainer" class="form-group form-input">
                    <label class="form-label" for="newUser{{i}}UserName" [class.error]="formControlInvalidAndTouched(i, formFieldNames.username.name)">
                      {{formFieldNames.username.label}}
                      <span aria-hidden="true">*</span>
                    </label>
                    <button tabindex="0"
                      id="newUser{{i}}UserNameTooltipButton"
                      type="button"
                      class="btn question-button-icon"
                      aria-label="tooltip"
                      [ngbTooltip]="'Provide the user name with which the user will log in.'"
                      triggers="mouseenter:mouseleave focus:blur click"
                      [placement]="['top-left', 'top', 'top-right']">
                      <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
                    </button>
                    <input id="newUser{{i}}UserName"
                      type="text" class="form-control"
                      required
                      aria-required="true"
                      [formControlName]="formFieldNames.username.name"
                      [class.is-invalid]="formControlInvalidAndTouched(i, formFieldNames.username.name)"
                      [attr.aria-invalid]="invalidUsername"
                      [attr.aria-describedby]="invalidUsername && isManagingStudent ? 'studentUsernameError' : ''"
                      [ngbTooltip]="(usesOneRoster && !userCanBeEditedIfOneRoster) ? oneRosterTooltipText : ''">
                    <div class="errorWrapper">
                      @if (formControlInvalidAndTouched(i, formFieldNames.username.name)) {
                        <span
                          class="errorText error"
                        id="studentUsernameError">{{nameFieldErrorText(i, formFieldNames.username.name)}}</span>
                      }
                    </div>
                  </div>
                }
                <!-- School dropdown -->
                @if (showSchoolDropdown) {
                  <div class="form-select form-control user-form-dropdown">
                    <label class="form-label" for="userFormSchoolDropdown">School</label>
                    <zbp-select
                      labelForId="userFormSchoolDropdown"
                      [items]="schools"
                      bindLabel="name"
                      bindValue="schoolId"
                      formControlName="schoolId"
                      (valueChange)="onSchoolSelected($event, i)"
                      [matchOptionWidth]="false"
                      [ngbTooltip]="!uf.get('schoolId')?.disabled ? 'Students can only be in one school at a time. Use this dropdown to transfer this student to another school within your district.' : oneRosterTooltipText"
                      customClass="no-error-placeholder school-dropdown" />
                  </div>
                }
                <!-- Password Fields -->
                @if (uf.get(formFieldNames.password.name) && hasPasswordFields) {
                  @if (isInEditMode) {
                    <h5 class="form-section-title">Change Password</h5>
                  }
                  <div class="form-group form-input edit-password-fields" [class.half-width]="isManagingTeacher">
                    <label class="form-label" for="newUser{{i}}Password" [class.error]="formControlInvalidAndTouched(i, formFieldNames.password.name)">{{formFieldNames.password.label}}</label>
                    <input
                      id="newUser{{i}}Password"
                      type="password"
                      class="form-control"
                      autocomplete="new-password"
                      [formControlName]="formFieldNames.password.name"
                      [class.is-invalid]="formControlInvalidAndTouched(i, formFieldNames.password.name)"
                      placement="auto"
                      tooltipClass="password-requirements-tooltip"
                      #passwordTooltip="ngbTooltip"
                      (input)="hideTooltip(passwordTooltip)"
                      [ngbTooltip]="uf.get(formFieldNames.password.name)?.disabled ? '' : passwordToolTipContent">
                    <div class="errorWrapper">
                      @if (formControlInvalidAndTouched(i, formFieldNames.password.name)) {
                        <span class="errorText error">Password Does Not Meet the Requirements</span>
                      }
                    </div>
                  </div>
                  <div class="form-group form-input edit-password-fields" [class.half-width]="isManagingTeacher">
                    <label class="form-label form-label--confirmPassword" for="newUser{{i}}ConfirmPassword" [class.error]="confirmPasswordInvalid(i)">{{formFieldNames.confirmPassword.label}}</label>
                    <input
                      id="newUser{{i}}ConfirmPassword"
                      type="password"
                      class="form-control"
                      autocomplete="new-password"
                      [formControlName]="formFieldNames.confirmPassword.name"
                      [class.is-invalid]="confirmPasswordInvalid(i)"
                      placement="auto"
                      tooltipClass="password-requirements-tooltip"
                      #confirmPasswordTooltip="ngbTooltip"
                      (input)="hideTooltip(confirmPasswordTooltip)"
                      [ngbTooltip]="uf.get(formFieldNames.confirmPassword.name)?.disabled ? '' : passwordToolTipContent">
                    <div class="errorWrapper">
                      @if (confirmPasswordInvalid(i)) {
                        <span class="errorText error">{{confirmPasswordFieldErrorText(i)}}</span>
                      }
                    </div>
                  </div>
                }
                @if (isInEditMode && (showStudentsList || showClassroomList)) {
                  <div class="form-row lists-section"
                    >
                    <!-- List of Students for Parent in Edit Mode -->
                    @if (showStudentsList) {
                      <div class="link-list-container" [class.half-width]="showClassroomList">
                        <h5 class="text-uppercase form-section-title black-font-title">Students</h5>
                        <ul class="links-list">
                          @for (student of getStudentsArray(uf)?.controls; track student; let studentIndex = $index) {
                            <li class="links-list-item">
                              <zbp-button-component
                                [theme]="'primaryTextLink'"
                                [label]="student.get('displayName')?.value"
                                class="classroom-link-button-container"
                                [customClass]="'classroom-link-button'"
                                (click)="openEditStudentModal($event, student.get('associatedUserId')?.value)">
                              </zbp-button-component>
                              <zbp-button-component
                                class="delete-student-from-parent"
                                [iconName]="'x_cross_circle'"
                                (clickHandler)="removeStudentFromParentClickHandler(i, studentIndex, student.get('displayName')?.value)"
                                [tooltip]="'Remove student from parent'"
                                [ariaLabel]="'Remove student from'"
                                theme="icon"
                                fontSizeUnit="rem"
                              ></zbp-button-component>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                    <!-- Lists of Classroom links in Edit Mode -->
                    @if (showClassroomList ) {
                      <div class="link-list-container" [class.half-width]="showStudentsList">
                        <h5 class="text-uppercase form-section-title black-font-title compact-section-title">Classrooms</h5>
                        @for (c of user.classrooms; track c.classroomId) {
                          <zbp-button-component
                            [theme]="'primaryTextLink'"
                            [label]="c.name"
                            class="classroom-link-button-container"
                            [customClass]="'classroom-link-button'"
                            (click)="goToClassroom($event, c)">
                          </zbp-button-component>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
              <!-- Parent Lists for Students in Edit Mode -->
              @if (hasParentFields && isInEditMode) {
                @for (parent of getParentsArray(uf)?.controls; track parent; let parentIndex = $index) {
                  <ul id="editParentFields{{parentIndex}}" [formArrayName]="'userAssociations'" class="form-row parent-fields-list">
                    <li class="parent-list-item" [formGroupName]="parentIndex">
                      <!-- Parent first name -->
                      <div class="form-group form-input">
                        <label for="newUser{{i}}{{parentIndex}}ParentFirstName" class="form-label">
                          {{formFieldNames.parentFirstName.label}}
                          <span aria-hidden="true">*</span>
                        </label>
                        <input id="newUser{{i}}{{parentIndex}}ParentFirstName"
                          type="text"
                          required
                          aria-required="true"
                          class="form-control no-error-placeholder"
                          [formControlName]="formFieldNames.parentFirstName.name"
                          [class.is-invalid]="parentFormControlInvalidAndTouched(parentIndex, i, formFieldNames.parentFirstName.name)"
                          [attr.aria-invalid]="invalidParentUsername"
                          [attr.aria-describedby]="invalidParentUsername ? 'parentFirstNameError' : ''" >
                        <div
                          class="errorWrapper">
                          @if (parentFormControlInvalidAndTouched(parentIndex, i, formFieldNames.parentFirstName.name)) {
                            <span
                              class="errorText error"
                            id="parentFirstNameError">{{parentNameFieldErrorText(parentIndex, i, formFieldNames.parentFirstName.name)}}</span>
                          }
                        </div>
                      </div>
                      <!-- Parent last name -->
                      <div class="form-group form-input">
                        <label for="newUser{{i}}{{parentIndex}}ParentLastName" class="form-label">
                          {{formFieldNames.parentLastName.label}}
                          <span aria-hidden="true">*</span>
                        </label>
                        <input id="newUser{{i}}{{parentIndex}}ParentLastName"
                          type="text"
                          required
                          aria-required="true"
                          class="form-control no-error-placeholder"
                          [formControlName]="formFieldNames.parentLastName.name"
                          [class.is-invalid]="parentFormControlInvalidAndTouched(parentIndex, i, formFieldNames.parentLastName.name)"
                          [attr.aria-invalid]="invalidParentLastName"
                          [attr.aria-describedby]="invalidParentLastName ? 'parentLastNameError' : ''" >
                        <div
                          class="errorWrapper">
                          @if (parentFormControlInvalidAndTouched(parentIndex, i, formFieldNames.parentLastName.name)) {
                            <span
                              class="errorText error"
                            id="parentLastNameError">{{parentNameFieldErrorText(parentIndex, i, formFieldNames.parentLastName.name)}}{{nameFieldErrorText(i, formFieldNames.parentLastName.name)}}</span>
                          }
                        </div>
                      </div>
                      <!-- Parent username -->
                      <div class="form-group form-input">
                        <label for="newUser{{i}}{{parentIndex}}ParentUserName" class="form-label">
                          {{formFieldNames.parentUserName.label}}
                          <span aria-hidden="true">*</span>
                        </label>
                        <input id="newUser{{i}}{{parentIndex}}parentUserName"
                          type="text"
                          required
                          aria-required="true"
                          class="form-control no-error-placeholder"
                          [formControlName]="formFieldNames.parentUserName.name"
                          [class.is-invalid]="parentFormControlInvalidAndTouched(parentIndex, i, formFieldNames.parentUserName.name)"
                          [attr.aria-invalid]="invalidParentUsername"
                          [attr.aria-describedby]="invalidParentUsername ? 'parentUsernameError' : ''" >
                        <div
                          class="errorWrapper">
                          @if (parentFormControlInvalidAndTouched(parentIndex, i, formFieldNames.parentUserName.name)) {
                            <span
                              class="errorText error"
                            id="parentUsernameError">{{parentNameFieldErrorText(parentIndex, i, formFieldNames.parentUserName.name)}}{{nameFieldErrorText(i, formFieldNames.parentUserName.name)}}</span>
                          }
                        </div>
                      </div>
                      <div class="parent-row-icons">
                        <div class="parent-login-indicator">
                          @if (parent.get('isSetup')?.value) {
                            <i class="fa fa-circle-check green-icon parent-indicator" aria-label="Parent setup" [ngbTooltip]="parentSetupToolTip" container="body"></i>
                          } @else {
                            <i class="fa fa-circle red-icon parent-indicator" aria-label="Parent not setup" [ngbTooltip]="parentNotSetupToolTip" container="body"></i>
                          }
                        </div>
                        <ng-template #parentSetupToolTip>
                          <span>This parent has set up their ZB Portal account and is able to log in.</span>
                        </ng-template>
                        <ng-template #parentNotSetupToolTip>
                          <span>This parent has not set up their ZB Portal account yet.</span>
                        </ng-template>
                        <zbp-button-component
                          class="resend-email-parent"
                          [iconName]="zbpIconNames.envelope"
                          (clickHandler)="resendParentEmail(i, parentIndex)"
                          [tooltip]="'Resend email to parent'"
                          [ariaLabel]="'Resend email to parent'"
                          theme="icon"
                          iconSize="font-size"
                          fontSizeUnit="rem"
                        ></zbp-button-component>
                        <zbp-button-component
                          class="delete-parent-row"
                          [iconName]="'x_cross_circle'"
                          (clickHandler)="removeParentFromFormClickHandler(i, parentIndex)"
                          [tooltip]="'Remove parent from student'"
                          [ariaLabel]="'Remove parent from student'"
                          theme="icon"
                          iconSize="font-size"
                          fontSizeUnit="rem"
                        ></zbp-button-component>
                      </div>
                    </li>
                  </ul>
                }
              }
              <!-- Additional Student Controls -->
              @if (isManagingStudent && (hasParentFields || isInEditMode)) {
                <div class="additional-student-controls">
                  <!-- Students can add multiple parents-->
                  @if (hasParentFields && isInEditMode) {
                    <zbp-button-component
                      [iconName]="zbpIconNames.t_cross"
                      iconSize="font-size"
                      theme="primaryText"
                      [label]="addParentButtonText"
                      iconPosition="left"
                      class="addAnotherButton"
                      [disabled]="isAddAnotherParentDisabled(i)"
                      [ngbTooltip]="isAddAnotherParentDisabled(i) ? 'Can only add 4 Parents to a Student.' : ''"
                      (clickHandler)="addAnotherParentClickHandler(i)"
                      >
                    </zbp-button-component>
                  }
                  <!-- Students can search parents -->
                  @if (isInEditMode && canManageParent) {
                    <div class="form-group form-input userSearch parent-search-box">
                      <label class="orSeparator" id="parent-search-dropdown-label">OR</label>
                      <zbp-user-search-with-dropdown
                        id="parent-search-dropdown"
                        aria-labelledby="parent-search-dropdown-label"
                        class="addSearchBox"
                        [i]="0"
                        [school]="school"
                        [role]="RoleType.Parent"
                        [control]="searchBox"
                        [itemSelectionFunction]="addParentRowFromUserSearchToStudent"
                        [pageSize]="10"
                        [activeOnly]="true"
                        [placeholderText]="'Search Existing Parents'"
                        [ngbTooltip]="isAddAnotherParentDisabled(i) ? 'Can only add 4 Parents to a Student.' : ''"
                        container="body"
                        [isDisabled]="isAddAnotherParentDisabled(i)"
                        >
                      </zbp-user-search-with-dropdown>
                    </div>
                  }
                </div>
              }
            </div>
            @if (!hideFirstRowDeleteButton ? true : i !== 0) {
              <button id="removeRow{{i}}" class="btn btn-sm removeButton text-end remove-button-container" type="button" [attr.aria-label]="'Remove User'" (click)="removeRow(i)">
                <i class="fa-regular fa-circle-xmark"></i>
              </button>
            }
          </div>
        }
        <div class="add-additional-user-controls">
          <!-- Add New Role Type being added -->
          @if (canAddMultipleUsers) {
            <div class="userSearch">
              @if (canAddMultipleUsers) {
                <zbp-button-component
                  [iconName]="zbpIconNames.t_cross"
                  iconSize="font-size"
                  theme="primaryText"
                  [label]="addAnotherUserLabel"
                  iconPosition="left"
                  class="addAnotherButton"
                  (clickHandler)="addAnother()"
                  [disabled]="newUsers?.length >= maxRequired"
                  >
                </zbp-button-component>
              }
            </div>
          }
          <!-- Search for user for Role Type being added -->
          @if (canUserSearch) {
            <div class="userSearch">
              <div class="orSeparator">OR</div>
              <zbp-user-search-with-dropdown
                class="addSearchBox"
                [i]="0"
                [school]="school"
                [role]="roleType"
                [control]="searchBox"
                [itemSelectionFunction]="userSearchSelectionFunction"
                [pageSize]="10"
                [activeOnly]="true"
                [placeholderText]="'Search Existing'"
                [isDisabled]="newUsers?.length >= maxRequired"
                >
              </zbp-user-search-with-dropdown>
            </div>
          }
        </div>
      </div>
    }
  </section>
} @else {
  <div class="preloader spinner">
    <zbp-preloader></zbp-preloader>
  </div>
}

